import { useAppSelector } from "@src/store/hooks";

const useOpenAuthModal = () => useAppSelector(({ auth }) => auth.openAuthModal);

export default useOpenAuthModal;
